module.exports = __webpack_public_path__ + "img/ios_hover.a2e2a117.png";